import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
export function PriceComparison() {
  return <section className="w-full bg-brand-violet px-6 py-16" data-id="element-180">
      <div className="max-w-xl mx-auto flex flex-col items-center text-center" data-id="element-181">
        <p className="text-white/80 text-[14px] font-bold uppercase tracking-widest mb-4" data-id="element-182">
          VALOR TOTAL DEL SISTEMA
        </p>
        <p className="text-white/50 text-[32px] font-bold line-through mb-2" data-id="element-183">
          $39.990
        </p>
        <p className="text-white text-[56px] font-bold leading-none mb-4" data-id="element-184">
          $19.990
        </p>
        <p className="text-white/90 text-[16px] leading-relaxed mb-8 max-w-sm" data-id="element-185">
          Menos que una consulta privada + una caja de óvulos que no funciona
        </p>

        <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
        content_name: 'Price Comparison CTA',
        value: 19990,
        currency: 'ARS'
      })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[16px] rounded-xl py-4 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-186">
          🔓 QUIERO EL MÉTODO pH-ZERO
        </a>
      </div>
    </section>;
}